/*
 * Rewinding the raw agent conversation for "Edit & restore". Only whole
 * trailing turns (and blocks appended to the last user message) are removed,
 * so the prefix already sent to the model, thinking blocks included, is
 * unchanged.
 */

function asBlockList(content) {
    return typeof content === "string" ? [{ type: "text", text: content }] : (content ?? []);
}

/**
 * Where the agent conversation stands before a prompt is added.
 * @param {Array<{ role: string, content: unknown }>|undefined} agentMessages
 * @returns {{ length: number, lastUserBlocks: number|null }}
 */
export function agentConversationMark(agentMessages) {
    const list = agentMessages ?? [];
    const last = list[list.length - 1];
    return {
        length: list.length,
        lastUserBlocks: last?.role === "user" ? asBlockList(last.content).length : null,
    };
}

/**
 * Plain copy of the conversation cut back to a mark.
 * @param {Array<{ role: string, content: unknown }>} agentMessages  plain (not a Svelte proxy)
 * @param {{ length: number, lastUserBlocks: number|null }|undefined} mark
 */
export function rewindAgentConversation(agentMessages, mark) {
    if (!mark || !Array.isArray(agentMessages)) return agentMessages;
    const kept = JSON.parse(JSON.stringify(agentMessages.slice(0, mark.length)));
    if (mark.lastUserBlocks !== null && kept.length) {
        const last = kept[kept.length - 1];
        last.content = asBlockList(last.content).slice(0, mark.lastUserBlocks);
    }
    return kept;
}
